import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'hooks';
import { usePostLoginMutation, useSetDeviceMutation } from 'services/modules/user';
import { setToken } from 'store/inspection';
import { Button, Input } from 'ui';

import { routes } from 'utils/routeConfig';

import useDetailDevice from '../../hooks/useDetailDevice';
import { isNotificationDefault, isNotificationPermission } from '../../utils/helpers';
import { requestForToken } from '../Firebase/firebase';

import { AppName, Container, FormContent } from './LoginElements';

export const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [username, setUsername] = useState('');
  const onChangeUsername = (e: React.FormEvent<HTMLInputElement>) => {
    setUsername(e.currentTarget.value);
  };
  const [password, setPassword] = useState('');
  const onChangePassword = (e: React.FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value.replace(' ', '');
    setPassword(value);
  };

  const [postLogin, { data, isLoading, isSuccess }] = usePostLoginMutation();

  const loginRequest = () => {
    if (username.length > 0 && password.length > 0) {
      postLogin({ username, password });
    }
  };

  const saveTokenAndNavigate = (token: string, isShowModal?: boolean) => {
    dispatch(setToken(token));
    localStorage.setItem('token', token);
    navigate({
      pathname: routes.dashboard,
      search: createSearchParams({
        modal: 'permission_notification',
      }).toString(),
    });
  };
  const { osDevice, osVersion, browser } = useDetailDevice();

  const [setDevices] = useSetDeviceMutation();

  const setTokenRequest = (token: string) => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      requestForToken(
        registrations.find((registrationItem: ServiceWorkerRegistration) =>
          registrationItem.active?.scriptURL.includes(
            process.env.NODE_ENV === 'production'
              ? 'firebase-messaging-sw-production.js'
              : 'firebase-messaging-sw-development.js',
          ),
        ),
      ).then((res) => {
        if (res) {
          localStorage.setItem('fcm_token', res);
          setDevices({
            platform: 'webapp',
            app: 'inspection',
            device_model: osDevice,
            fcm_token: res,
            app_version: '0.1',
            os_version: osVersion ? osVersion.toString() : undefined,
            screen_size: `${window.innerWidth}*${window.innerHeight}`,
          });
        }
      });
    });

    setTimeout(() => {
      saveTokenAndNavigate(token);
    }, 1000);
  };

  useEffect(() => {
    if (isSuccess && data && data.token) {
      if (isNotificationDefault) {
        if (browser !== 'SAFARI') {
          Notification.requestPermission()
            .then((permission) => {
              if (permission === 'granted') {
                setTokenRequest(data.token);
              } else {
                saveTokenAndNavigate(data.token);
              }
            })
            .catch((e) => {
              console.log(e, 'e');
            });
        } else {
          setTokenRequest(data.token);
        }
      } else if (!isNotificationPermission) {
        saveTokenAndNavigate(data.token);
      } else {
        setTokenRequest(data.token);
      }
    }
  }, [isSuccess, data]);

  return (
    <Container>
      <AppName>
        <h1>{t('auth.app_name')}</h1>
        <h3>{t('auth.company_name')}</h3>
      </AppName>
      <FormContent>
        <Input label={t('auth.username')} value={username} onChange={onChangeUsername} />
        <Input
          type="password"
          label={t('auth.password')}
          value={password}
          onChange={onChangePassword}
        />
        <Button
          label={t('auth.login')}
          onClick={loginRequest}
          disabled={username.length === 0 || password.length === 0}
          isLoading={isLoading}
        />
      </FormContent>
    </Container>
  );
};
